import React from "react";
import "./style.css";
import { UnderlinedTitle } from "../UnderlinedTitle";

export const CourseLandingCertificate = ({ language }) => {

  const translations = {
    "es": "A todos nos gusta enseñarle al mundo que estamos en constante aprendizaje. A tus clientes les gustará verlo. Es por eso que nuestro Certificado 10 Masters incluye un código QR para verificar que has terminado este curso. Además, podrás escoger entre 5 diseños diferentes para que se adapte al estilo de tu estudio.",
    "en": "We all like showing how we’re constantly learnink. Your clients like seeing it too. That’s why our 10 Masters Certificate, which you’ll receive when you finish the course, includes a QR code to verify that you’ve learnt with me. Plus, you’ll be able to choose between 5 different templates - so it fits your studio’s style.",
    "pt": "Todos nós gostamos de mostrar ao mundo que estamos constantemente aprendendo. Seus clientes vão gostar de ver. É por isso que nosso 10 Masters Certificado inclui um código QR para verificar se você concluiu este curso. Além disso, você pode escolher entre 5 desenhos diferentes para se adequar ao estilo do seu estúdio.",
    "fr": "Nous aimons tous montrer au monde que nous apprenons constamment. Vos clients aimeront le voir. C'est pourquoi notre certificat 10 Masters comprend un code QR pour vérifier que vous avez terminé ce cours. De plus, vous pouvez choisir entre 5 modèles différents en fonction du style de votre étude.",
  };

  const title_translations = {
    "es": "CERTIFICADO 10 MASTERS",
    "en": "10 MASTERS CERTIFICATE",
    "pt": "CERTIFICADO 10 MASTERS",
    "fr": "CERTIFICAT 10 MASTERS",
  };


  const loop_translations = {
    "es": "https://newcdn.10masters.com/media/original_videos/LOOP_MC_9_ESP.m4v",
    "en": "https://newcdn.10masters.com/media/original_videos/LOOP_MC_9_ENG.m4v",
    "pt": "https://newcdn.10masters.com/media/original_videos/LOOP_MC_9_ENG.m4v",
    "fr": "https://newcdn.10masters.com/media/original_videos/LOOP_MC_9_ENG.m4v",
  };


  return (
    <div className="course_landing_certificate">
      <UnderlinedTitle text={title_translations[language]} />
      <div className="mt-5 mb-5 course_landing_certificate_video_container">
        <video className="course_landing_certificate_video" autoPlay muted loop playsInline>
          <source type="video/mp4" src={loop_translations[language]} />
        </video>
      </div>
      <div className="course_landing_certificate_text" dangerouslySetInnerHTML={{__html: translations[language]}}>
      </div>
    </div>
  );
};
